import { CheckIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";

const COPIED_FEEDBACK_MS = 2000;

interface CopyButtonProps {
  className?: string;
  value: string;
}

export const CopyButton = ({ className = "", value }: CopyButtonProps) => {
  const { t } = useTranslation("contact");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    const timeout = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
    return () => clearTimeout(timeout);
  }, [copied]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      // Brak dostępu do schowka (np. HTTP) - wartość nadal można zaznaczyć ręcznie
    }
  };

  return (
    <button
      aria-label={`${t("actions.copy")}: ${value}`}
      className={`inline-flex size-8 shrink-0 items-center justify-center rounded-md text-gray-400 transition hover:bg-gray-100 hover:text-[#051124] focus-visible:outline-2 focus-visible:outline-[#c1a166] ${className}`}
      onClick={handleCopy}
      title={copied ? t("actions.copied") : t("actions.copy")}
      type="button"
    >
      {copied ? (
        <CheckIcon aria-hidden="true" className="size-4 text-emerald-600" />
      ) : (
        <ClipboardDocumentIcon aria-hidden="true" className="size-4" />
      )}
      <span aria-live="polite" className="sr-only">
        {copied ? t("actions.copied") : ""}
      </span>
    </button>
  );
};
